import { Component, OnInit} from '@angular/core'
import { FaqService } from '../services/faq.service';

@Component({
  selector: 'faq',
  templateUrl: './faq.component.html',
})
export class FaqComponent implements OnInit {
   remittanceList: any;
   generalList: any;
  //  smartCurrencyCardList: any;
   foreignCurrencyList: any;
   VideoKycList: any;
   TcsList: any;
   forexCardList: any;
   public showLoader : boolean = true;
  selectedCategory: string;


  constructor(public faqService : FaqService) {}

  ngOnInit(){
    this.getRemittenceListAll();
    this.getGeneralListAll();
    // this.getSmartCurrencyCardListAll();
    this.getForeignCurrencyListAll();
    this.getVideoKycListAll();
    this.getTcsListAll();
    this.getforexCardListAll();
  }

  getRemittenceListAll(){
    this.showLoader = true;
    this.faqService.getRemittanceJSON().subscribe(res=>{
      this.showLoader = false;
      this.remittanceList = res;
    })
  }

  getGeneralListAll(){
    this.showLoader = true;
    this.faqService.getGeneralJSON().subscribe(res=>{
      this.showLoader = false;
      this.generalList = res;
    })
  }

  // getSmartCurrencyCardListAll(){
  //   this.showLoader = true;
  //   this.faqService.getSmartCurrencyCardJSON().subscribe(res=>{
  //     this.showLoader = false;
  //     this.smartCurrencyCardList = res;
  //   })
  // }

  getForeignCurrencyListAll(){
    this.showLoader = true;
    this.faqService.getForeignCurrencyJSON().subscribe(res=>{
      this.showLoader = false;
      this.foreignCurrencyList = res;
    })
  }

  getVideoKycListAll(){
    this.showLoader = true;
    this.faqService.getVideoKycJSON().subscribe(res=>{
      this.showLoader = false;
      this.VideoKycList = res;
    })
  }
  getTcsListAll(){
    this.showLoader = true;
    this.faqService.getTcsJSON().subscribe(res=>{
      this.showLoader = false;
      this.TcsList = res;
    })
  }
 getforexCardListAll() {
  this.showLoader = true;
  this.faqService.getforexCardJSON().subscribe((res: any) => {
    this.showLoader = false;
    this.forexCardList = res.forexCards;
    this.selectedCategory = 'xplorerc'; 
  });
}

setCategory(category: string) {
  this.selectedCategory = category;
}
}